// extracted by mini-css-extract-plugin
export default {"localUpload":"localUpload___Yvem7","progressBox":"progressBox___Kat9j"};